import { createSlice } from "@reduxjs/toolkit";

export const formUpdateSlice = createSlice({
  name: "formUpdate",
  initialState: {
    displayForm: false,
    imageUpload: false,
    formData: {},
  },
  reducers: {
    updateFormInfo: (state, data) => {
      console.log("payload", data.payload.formData);
      state.formData = data.payload.formData;
      state.displayForm = data.payload.displayForm;
      state.imageUpload = data.payload.imageUpload;
    },

    displayForm: (state, data) => {
      console.log("payload", data.payload.formData);
      state.displayForm = data.payload.displayForm;
    },
  },
});

export const { updateFormInfo, displayForm } = formUpdateSlice.actions;

export const formUpdateData = (state) =>
  state.rootReducer.formUpdateReducer.formData;

export const formUpdateStatus = (state) =>
  state.rootReducer.formUpdateReducer.displayForm;

export const imageUploadStatus = (state) =>
  state.rootReducer.formUpdateReducer.imageUpload;

export default formUpdateSlice.reducer;
